import { createFileRoute, Link } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { LxpLayout } from "@/components/lexpractiq/LxpLayout";
import { supabase } from "@/integrations/supabase/client";
import { listOpenFirmAssignments, submitFirmAssignment } from "@/lib/api/lxp-firms.functions";

export const Route = createFileRoute("/_authenticated/lexpractiq/firms/assignment/$id")({
  head: () => ({ meta: [{ title: "Firm assignment | SA LexPractiq" }] }),
  component: AssignmentPage,
});

function AssignmentPage() {
  const { id } = Route.useParams();
  const listFn = useServerFn(listOpenFirmAssignments);
  const submitFn = useServerFn(submitFirmAssignment);
  const [a, setA] = useState<any | null>(null);
  const [body, setBody] = useState("");
  const [existingResponseId, setExistingResponseId] = useState<string | null>(null);

  useEffect(() => {
    listFn().then((r) => setA(r.assignments.find((x: any) => x.id === id) ?? null));
    (async () => {
      const { data: user } = await supabase.auth.getUser();
      if (!user.user) return;
      const { data } = await supabase
        .from("lxp_firm_submissions")
        .select("id,body_html")
        .eq("assignment_id", id).eq("user_id", user.user.id).maybeSingle();
      if (data) { setBody(data.body_html || ""); setExistingResponseId(data.id); }
    })();
  }, [id]);

  async function send() {
    if (body.length < 20) return toast.error("Please write at least 20 characters");
    try { await submitFn({ data: { assignmentId: id, body } }); toast.success("Submitted"); }
    catch (e: any) { toast.error(e?.message); }
  }

  if (!a) return <LxpLayout><div className="lxp-container" style={{ padding: "2rem 1.25rem" }}><p>Loading…</p></div></LxpLayout>;

  return (
    <LxpLayout>
      <div className="lxp-container" style={{ padding: "2rem 1.25rem", maxWidth: 820 }}>
        <Link to="/lexpractiq/firms" className="lxp-btn-ghost" style={{ display: "inline-flex", marginBottom: "1rem" }}><ArrowLeft size={14} /> All firms</Link>
        {a.firm && <span className="lxp-badge">{a.firm.name}</span>}
        <h1 style={{ margin: "0.5rem 0" }}>{a.title}</h1>
        {a.deadline && <p className="lxp-muted" style={{ margin: 0 }}>Due {new Date(a.deadline).toLocaleString()}</p>}
        <div className="lxp-card" style={{ marginTop: "1rem", whiteSpace: "pre-wrap" }}>{a.brief}</div>

        <h3 style={{ marginTop: "1.5rem" }}>Your submission</h3>
        <textarea className="lxp-textarea" rows={14} value={body} onChange={(e) => setBody(e.target.value)} placeholder="Draft your response here…" />
        <div style={{ marginTop: "0.5rem" }}>
          <button className="lxp-btn" onClick={send}>{existingResponseId ? "Update submission" : "Submit"}</button>
        </div>
      </div>
    </LxpLayout>
  );
}
